import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export interface AccessLevelDTO {
    id: string
    accountId: string
    name: string
    originTimestamp: string
    deleted: boolean
    version: number
    permissions: PermissionDTO[]
}

export interface PermissionDTO {
    id: string
    accountId: string
    name: string
    version: number
    accessLevelId: string
    originTimestamp: string
}

export const getAccessAndRolesApi = (headers: Record<string, any>): Rx.Observable<AccessLevelDTO[]> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: "/access-level",
            headers: headers,
        })
    ).pipe(retry(2))
